"use client";

import type { PaymentResult } from "../../../lib/types/schema/subscription/cartSchema";
import { productsSchema } from "../../../lib/types/schema/subscription/productSchema";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyGiftCards } from "./keyProducts";

type UseRequestGiftProps = {
  isQuery?: boolean;
};

export const useRequestGift = ({
  isQuery = true,
}: UseRequestGiftProps = {}) => {
  return {
    query: useRequestQuery({
      queryFnRequestProps: {
        schema: productsSchema,
        urlBackendPath: "/products/gift-cards",
        requestType: "default",
      },
      enabled: isQuery,
      enabledWithoutSessionToken: true,
      queryKey: keyGiftCards(),
    }),
    mutationPurchase: useRequestMutation({
      mutationFnRequestProps: (
        data: PaymentResult & { count: number; priceId: string },
      ) => ({
        body: JSON.stringify({
          count: data.count,
          payment_method: data.paymentMethod,
          payment_platform: data.paymentPlatform,
          price_id: data.priceId,
          email: data.email,
        }),
        method: "POST",
        urlBackendPath: "/gift",
        requestType: "default",
      }),
    }),
    mutationAuthPurchase: useRequestMutation({
      mutationFnRequestProps: (
        data: PaymentResult & { count: number; priceId: string },
      ) => ({
        body: JSON.stringify({
          count: data.count,
          payment_method: data.paymentMethod,
          payment_platform: data.paymentPlatform,
          price_id: data.priceId,
          email: data.email,
        }),
        method: "POST",
        urlBackendPath: "/gift/web",
        requestType: "authenticated",
      }),
    }),
  };
};
